import {useTranslation} from "react-i18next";
import Skeleton from "react-loading-skeleton";
import React from "react";

export default function SettingsEmailInputs({ ...props }) {
    const { t } = useTranslation();

    //get use hook form methods
    const { register, formState: { errors } } = props.methods;
    //set a validation object
    const validation = {
        required: "validations.required",
        pattern: {
            value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: "validations.email"
        }
    }; //create register
    const inputProps = register(props.name, (props.validation)?{ ...props.validation, ...validation }:validation);

    return (
        <>
            <label htmlFor={props.name} className="form-label form-label">
                { t('email') }
            </label>
            { props.isLoading && <div><Skeleton style={{lineHeight: "39px"}} /></div> }
            { !props.isLoading && <input {...inputProps} placeholder={(props.placeholder)??"john@example.com"} type="search" className={`form-control ${(errors[props.name]?.message)?"is-invalid":""}`} /> }
            {  errors[props.name]?.message && <div className="invalid-feedback-always">{t(errors[props.name]?.message)}</div> }
        </>
    )
}

